/* eslint-disable import/prefer-default-export */
export const workflowStatusOptions = [
  { label: 'Needs review', value: 'needsReview' },
  { label: 'Returned', value: 'returned' },
  { label: 'Approved', value: 'approved' },
];

export const REWRITE_BUTTON_ID = 'rewrite-content';
